"use client";

import { createContext, useState } from "react";
import { usePathname } from "next/navigation";

export const HelpCenterContext = createContext({
  faqContent: null,
  faqSections: null,
  searchState: {
    value: "",
    onChange: () => {},
  },
});

export default function HelpCenterProvider({ children, value }) {
  const pathname = usePathname();
  const [search, setSearch] = useState({ pathname, text: "" });
  const searchState = {
    value: search.pathname === pathname ? search.text : "",
    onChange: (text) => setSearch({ pathname, text }),
  };
  return <HelpCenterContext.Provider value={{ ...value, searchState }}>{children}</HelpCenterContext.Provider>;
}
